import React, { useEffect, useState } from "react";
import { createBankDetail, updateBankDetail, getBankDetail } from "./api";
import styles from "./Form.module.css";

const initialForm = {
  account_name: "",
  account_number: "",
  ifsc_code: "",
  bank_name: "",
  branch_name: "",
  upi_id: "",
  secure_offline_text: "Secure offline donation",
  tax_benefit_text: "Eligible for 80G tax benefits",
  transparent_text: "Transparent fund utilization",
  status: "Inactive",
};

export default function BankDetailsAdd() {
  const [form, setForm] = useState(initialForm);
  const [qrFile, setQrFile] = useState(null);
  const [currentQr, setCurrentQr] = useState(null);
  const [statusMessage, setStatusMessage] = useState("");
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    if (!id) return;

    setEditId(id);
    getBankDetail(id)
      .then((res) => {
        if (res.item) {
          setForm({
            account_name: res.item.account_name || "",
            account_number: res.item.account_number || "",
            ifsc_code: res.item.ifsc_code || "",
            bank_name: res.item.bank_name || "",
            branch_name: res.item.branch_name || "",
            upi_id: res.item.upi_id || "",
            secure_offline_text: res.item.secure_offline_text || initialForm.secure_offline_text,
            tax_benefit_text: res.item.tax_benefit_text || initialForm.tax_benefit_text,
            transparent_text: res.item.transparent_text || initialForm.transparent_text,
            status: res.item.status || "Inactive",
          });
          setCurrentQr(res.item.qr_code_path || null);
        }
      })
      .catch(() => {
        setStatusMessage("Failed to load bank details for editing");
      });
  }, []);

  function updateField(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  async function onSubmit(e) {
    e.preventDefault();
    setStatusMessage("");
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => formData.append(key, value));
    if (qrFile) {
      formData.append("qr_code", qrFile);
    }

    try {
      if (editId) {
        formData.append("id", String(editId));
        formData.append("_method", "PUT");
        await updateBankDetail(editId, formData);
        setStatusMessage("Bank details updated successfully.");
      } else {
        await createBankDetail(formData);
        setStatusMessage("Bank details saved successfully.");
        setForm(initialForm);
        setQrFile(null);
        setCurrentQr(null);
      }
    } catch (error) {
      setStatusMessage(error.message || "Failed to save bank details");
    }
  }

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>{editId ? "Edit Bank Details" : "Add Bank Details"}</h2>
      {statusMessage && <p>{statusMessage}</p>}
      <form className={styles.grid} onSubmit={onSubmit}>
        <div className={styles.row}>
          <div className={styles.label}>Account Name</div>
          <input className={styles.input} name="account_name" value={form.account_name} onChange={updateField} placeholder="Account Name" required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Account Number</div>
          <input className={styles.input} name="account_number" value={form.account_number} onChange={updateField} placeholder="Account Number" required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>IFSC Code</div>
          <input className={styles.input} name="ifsc_code" value={form.ifsc_code} onChange={updateField} placeholder="IFSC Code" required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Bank Name</div>
          <input className={styles.input} name="bank_name" value={form.bank_name} onChange={updateField} placeholder="Bank Name" required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Branch Name</div>
          <input className={styles.input} name="branch_name" value={form.branch_name} onChange={updateField} placeholder="Branch Name" required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>UPI ID</div>
          <input className={styles.input} name="upi_id" value={form.upi_id} onChange={updateField} placeholder="UPI ID" required />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Secure Offline Text</div>
          <input className={styles.input} name="secure_offline_text" value={form.secure_offline_text} onChange={updateField} placeholder="Secure offline donation text" />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Tax Benefit Text</div>
          <input className={styles.input} name="tax_benefit_text" value={form.tax_benefit_text} onChange={updateField} placeholder="80G tax benefit text" />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Transparent Text</div>
          <input className={styles.input} name="transparent_text" value={form.transparent_text} onChange={updateField} placeholder="Transparent fund utilization text" />
        </div>
        <div className={styles.row}>
          <div className={styles.label}>Status</div>
          <select className={styles.input} name="status" value={form.status} onChange={updateField}>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
        <div className={styles.row}>
          <div className={styles.label}>QR Code</div>
          <input className={styles.file} type="file" accept="image/png, image/jpeg, image/jpg, image/webp" onChange={(e) => setQrFile(e.target.files?.[0] || null)} />
        </div>
        {currentQr && !qrFile && (
          <div className={styles.row}>
            <div className={styles.label}>Current QR</div>
            <div>
              <div style={{ width: 120, height: 120, overflow: 'hidden', borderRadius: 12, border: '1px solid #e5e7eb' }}>
                <img src={currentQr} alt="Current QR code" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
            </div>
          </div>
        )}
        <div className={styles.actions}>
          <button className={styles.button} type="submit">{editId ? "Update" : "Save"}</button>
        </div>
      </form>
    </div>
  );
}
